module.exports = __webpack_public_path__ + "img/V-R-3-unload-connect.e1e00888.png";